import $ from "jquery";
import React from 'react';
import { Button, Grid, Input, Form, TextArea } from 'semantic-ui-react';

import Server from '../../../functions/server';

class Title extends React.Component {

  state = {
    
  }

  componentDidMount() {
    this.setState({
      invoice_no: this.props.item.dms_invoice_no,
      invoice_date: this.props.item.dms_invoice_date,
      invoice_amount: this.props.item.dms_invoice_value,
      invoice_remarks: this.props.item.remarks,
    })
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value, }); }

  submit() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Change DMS Values!!!');
      return;
    }
    let context = this;
    let item = this.props.item;
    let  { invoice_no, invoice_date, invoice_amount, invoice_remarks } = this.state;
    $.ajax({
      type: 'POST', data: { invoice_no, invoice_date, invoice_amount, invoice_remarks, mid: item.masterId }, 
      url: Server() + 'quotation/updatedmsvalue.php',
      success: function(data) {
        console.log(data);
        if (data == 1) {
          alert('Saved');
          context.props.refresh();
          context.props.close();
        }
        else {
          alert('Error to Save Data!!!')
        }
      },
      error: function(err) {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
    
  }

  render() {
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={5}>
            <b>Invoice No</b><br/>
            <Input fluid value={this.state.invoice_no} onChange={this.handleChange('invoice_no')} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={5}>
            <b>Invoice Date</b><br/>
            <input type="date"  id="date" value={this.state.invoice_date}
              style={{width: '100%', height: 35 }} onChange={this.handleChange('invoice_date')} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={5}>
            <b>Invoice Amount</b><br/>
            <Input fluid value={this.state.invoice_amount} onChange={this.handleChange('invoice_amount')} /> 
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <b>Remarks</b><br/>
            <Form>
              <TextArea fluid value={this.state.invoice_remarks} onChange={this.handleChange('invoice_remarks')} />
            </Form>
          </Grid.Column>
        </Grid>
        <br/>
        <center>
          <Button onClick={ () => { this.props.close(); }}>Cancel</Button>
          <Button style={{marginLeft: '5px'}} onClick={this.submit.bind(this)}>Submit</Button>
        </center>
      </div>
    );
  }
}

export default Title;
